"use client";

import { useCurrentDeviceContext } from "@grupa-pracuj/ui-library-sip";
import { Typography } from "@grupa-pracuj/ui-system";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import PrefetchOnIntentLink from "@/components/PrefetchOnIntentLink";
import { getResolvedArchiveSearchParams } from "@/utils";
import styles from "./TimelineItem.module.css";

const TimelineItem = ({
  year,
  months,
}: {
  year: number;
  months: { id: string; name: string }[];
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { isMobile } = useCurrentDeviceContext();
  const searchParams = useSearchParams();
  const { year: activeYear, month: activeMonth } =
    getResolvedArchiveSearchParams({
      year: searchParams.get("year"),
      month: searchParams.get("month"),
      pageNumber: searchParams.get("pageNumber"),
    });
  const monthsListId = `months-list-${year}`;
  const yearToggleActionLabel = isOpen ? "ukryj" : "pokaż";
  const yearAriaLabel = isMobile
    ? `Rok ${year}, ${yearToggleActionLabel} miesiące`
    : undefined;

  const handleYearClick = () => {
    if (!isMobile) {
      return;
    }

    setIsOpen((previous) => !previous);
  };

  return (
    <li className={styles.yearItem}>
      <Typography
        onClick={handleYearClick}
        size="small"
        component="button"
        type="button"
        className={styles.yearButton}
        aria-label={yearAriaLabel}
        aria-controls={isMobile ? monthsListId : undefined}
        aria-expanded={isMobile ? isOpen : undefined}
        tabIndex={isMobile ? 0 : -1}
      >
        {year}
      </Typography>
      <ul
        id={monthsListId}
        className={`${styles.monthsList} ${isOpen ? styles.monthsListOpen : ""}`}
      >
        {months.map(({ id, name }) => {
          const month = Number(id.split("-")[1]);
          const isActiveMonth =
            Number(activeYear) === year && Number(activeMonth) === month;

          return (
            <li key={id} className={styles.monthItem}>
              <PrefetchOnIntentLink
                className={styles.monthLink}
                href={`/?year=${year}&month=${month}&pageNumber=1`}
                ariaCurrent={isActiveMonth ? "page" : undefined}
              >
                {name}
              </PrefetchOnIntentLink>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default TimelineItem;
